import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/icon/edit.png';
import _imports_1 from '@/assets/icon/tick.png';
const _withScopeId = n => (_pushScopeId("data-v-2d062f2a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "adressPage" };
const _hoisted_2 = { class: "addressBox" };
const _hoisted_3 = { class: "flex-align-center addressTop" };
const _hoisted_4 = { class: "consigneeName flex-align-center" };
const _hoisted_5 = { class: "consigneePhone" };
const _hoisted_6 = { class: "defaultFont" };
const _hoisted_7 = { class: "addressDetail" };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "editImg" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        src: _imports_0,
        alt: ""
    })
], -1));
const _hoisted_9 = { class: "flex-align-center addressBottom" };
const _hoisted_10 = ["onClick"];
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_1,
    alt: ""
}, null, -1));
const _hoisted_12 = [
    _hoisted_11
];
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "" }, " 默认地址", -1));
const _hoisted_14 = ["onClick"];
const _hoisted_15 = { class: "noMore" };
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "bottomBtn" }, [
    /*#__PURE__*/ _createElementVNode("button", {
        class: "submitInput",
        type: "submit"
    }, "添加新地址")
], -1));
import { Toast } from 'vant';
import { getAddressList, addressDelete } from '@/api/invoice';
import Header from '@/components/common/Header.vue';
import Empty from '@/components/common/Empty.vue';
import { appPort, closeWebView } from '@/widget/index';
import { ref, onMounted, getCurrentInstance } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const { proxy: { $dialog, $showLoading, $hideLoading } } = getCurrentInstance();
        const addressId = ref(0);
        const isApp = ref(appPort());
        const pageNo = ref(1);
        const pageCount = ref(1);
        const flag = ref(true);
        const addressList = ref([]);
        const backFn = () => {
            if (isApp.value) {
                closeWebView();
            }
            else {
                history.go(-1);
            }
        };
        const getList = () => {
            $showLoading();
            getAddressList({
                page: pageNo.value
            }).then((res) => {
                $hideLoading();
                if (res.code === 200) {
                    addressList.value = res.data.items;
                }
            });
        };
        const deleteBtn = (id) => {
            $dialog
                .confirm({
                title: '',
                message: '确定删除此地址？'
            })
                .then(() => {
                addressDelete({
                    addressId: id
                }).then((res) => {
                    if (res.code === 200) {
                        Toast('地址删除成功!');
                        getList();
                    }
                });
            });
        };
        const setDefault = () => { };
        onMounted(() => {
            getList();
        });
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Header, {
                    onBackFn: backFn,
                    showBack: true,
                    isColor: true,
                    pageTitle: '地址管理'
                }),
                _createElementVNode("ul", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addressList.value, (item, key) => {
                        return (_openBlock(), _createElementBlock("li", { key: key }, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", null, [
                                    _createElementVNode("p", _hoisted_4, [
                                        _createElementVNode("span", null, _toDisplayString(item.userName), 1),
                                        _createElementVNode("span", _hoisted_5, _toDisplayString(item.phone), 1),
                                        _withDirectives(_createElementVNode("span", _hoisted_6, "默认", 512), [
                                            [_vShow, item.isDefault]
                                        ])
                                    ]),
                                    _createElementVNode("p", _hoisted_7, _toDisplayString(item.addressConcat), 1)
                                ]),
                                _createVNode(_component_router_link, { to: "/address/add" }, {
                                    default: _withCtx(() => [
                                        _hoisted_8
                                    ]),
                                    _: 1
                                })
                            ]),
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", {
                                    class: "flex delaultIcon",
                                    onClick: _withModifiers(setDefault, ["stop"])
                                }, [
                                    _createElementVNode("div", {
                                        class: _normalizeClass(["checkmark", { active: item.isDefault }])
                                    }, _hoisted_12, 2),
                                    _hoisted_13
                                ], 8, _hoisted_10),
                                _createElementVNode("div", {
                                    class: "addressDelete",
                                    onClick: _withModifiers(($event) => (deleteBtn(item.addressId)), ["stop"])
                                }, " 删除 ", 8, _hoisted_14)
                            ])
                        ]));
                    }), 128))
                ]),
                _withDirectives(_createVNode(Empty, { text: '暂无内容，探索一下其他内容吧~' }, null, 512), [
                    [_vShow, flag.value && addressList.value.length === 0]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_15, "没有更多了", 512), [
                    [_vShow, flag.value && pageCount.value === pageNo.value]
                ]),
                _hoisted_16
            ]));
        };
    }
});
